/* Browser-Autofill (Chrome/Edge/Safari) färbt nur das innere <input> hellblau. Bei Feldern mit Symbol oder
   Augen-Knopf (Antd-Affix, Kit-Feld) bleibt der Rahmen in Feldfarbe — die Füllung wirkt halb und fremd.
   Statt einer zweiten Farbfläche (box-shadow inset) bleibt der Hintergrund des Felds stehen: Der Farbwechsel
   des Browsers wird endlos verzögert, Text und Cursor folgen dem Theme. Gilt für alle Produkte und die
   Anmeldeflächen; produkteigene Autofill-Regeln entfallen. */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:-webkit-autofill:active,
select:-webkit-autofill {
  -webkit-text-fill-color: var(--mq-auth-text, var(--mq-theme-text, currentColor)) !important;
  caret-color: var(--mq-auth-caret, var(--mq-theme-text, currentColor));
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  transition: background-color 9999999s ease-out 0s, color 9999999s ease-out 0s !important;
}
